import React from 'react';
import {Modal} from 'components';
import {lookupBatch, lookupSingle} from 'assets/images/images';
import {ChevronRight} from 'lucide-react';

function PerformSearchModal({
  show,
  onClose,
  onSingleSearchClick,
  onBatchLookup,
}) {
  return (
    <Modal
      show={show}
      onClose={onClose}
      modalTitle="Choose Lookup"
      modalSubTitle="Select the type of lookup you would like to perform"
      extraModalClasses="max-w-[444px]"
      modalPosition="items-start justify-end"
    >
      <div>
        <button
          className="p-6 mt-2 flex items-center justify-between w-full border-[0.5px] border-transparent border-b-[#EFEFEF]"
          onClick={onSingleSearchClick}
        >
          <div className="flex items-center gap-4">
            <img src={lookupSingle} alt="Single Lookup" />
            <p className="text-[#080917] text-sm font-medium">
              Lookup single AML
            </p>
          </div>
          <ChevronRight color="#84858D" size={20} />
        </button>
        <button
          onClick={onBatchLookup}
          className="p-6 mt-2 flex items-center justify-between w-full"
        >
          <div className="flex items-center gap-4">
            <img src={lookupBatch} alt="Batch Lookup" />
            <p className="text-[#080917] text-sm font-medium">
              Lookup batch AML
            </p>
          </div>
          <ChevronRight color="#84858D" size={20} />
        </button>
        <div className="w-full border-[0.5px] border-transparent border-t-[#EFEFEF] p-3" />
      </div>
    </Modal>
  );
}

export default PerformSearchModal;
